export default __webpack_public_path__ + "static/media/1x3.9e2a1a1d.svg";